<template>
  <v-container fluid>
    <v-row dense justify="center">
      <v-col style="min-width: 380px">
        <Connection :loading="loading" :config="config.r_keeper_server" ref="connection" @ping="ping"/>
      </v-col>
      <v-col style="min-width: 300px">
        <Ping ref="ping"/>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <SaasXml :loading="loading" :use_tcp="!!config.r_keeper_server.use_tcp" :config="use_saas_isolated" :original_value="config.use_saas" ref="saasxml" />

      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import Ping from './PingInfo.vue'
import settings_group_mixin from '../settings_group_mixin'
import Connection from'./Connection.vue'
import SaasXml from './SaasXml.vue'

export default {
  mixins: [settings_group_mixin],
  methods: {
    submit() {
      let config = {r_keeper_server: {}}
      config.r_keeper_server = this.$refs.connection.submit()
      config.r_keeper_server = {...config.r_keeper_server, ...this.$refs.saasxml.submit()}
      return config
    },
    ping(){
      this.$refs.ping.pingNow()
    }
  },
  computed:{
    use_saas_isolated(){
      return {use_saas: this.config.r_keeper_server.use_saas}
    }
  },
  components:{
    Connection,
    Ping,
    SaasXml
  }
}
</script>